// Interfaces
import { IDropdown } from 'interfaces/common';

// Constant
import { ApiSuccessConstant } from 'constant';

// Fake Response
export const FAKE_RESPONSE = {
  config: {},
  message: ApiSuccessConstant.OK,
  ok: true,
  status: 200,
};

export const STATUS: IDropdown[] = [
  { value: true, label: 'app.status.active' },
  { value: false, label: 'app.status.inactive' },
];

export const COMPANY_TYPE: IDropdown[] = [
  { value: '1', label: 'Internal' },
  { value: '0', label: 'External' },
];

export enum ASSESSMENT_PROOFS {
  GENERAL = 'GENERAL',
  RELEVANT = 'RELEVANT',
}

export enum ASSESSMENT_STATUS {
  APPROVED = 'Approved',
  COMPLETED = 'Completed',
  DRAFT = 'Draft',
  ON_PROGRESS = 'On Progress',
  REJECTED = 'Rejected',
  WAITING_APPROVAL = 'Waiting Approval',
  WAITING_ASSESSMENT = 'Waiting Assessment',
  WAITING_CERTIFICATION = 'Waiting Certification',
  WAITING_PREPARATION = 'Waiting Preparation',
  WAITING_RESULT = 'Waiting Result',
  WAITING_SCHEDULING = 'Waiting Scheduling',
  CERTIFICATION = 'Certification',
  WAITING_NEXT_PROCESS = 'Wait for Next Process',
  FINISHED = 'Finished',
}

export enum USER_STATUS {
  APPROVED = 'Disetujui',
  REJECTED = 'Ditolak',
  NOT_REGISTERED_LSP = 'Tidak Terdaftar Di LSP',
  WAITING_APPROVAL = 'Menunggu Persetujuan',
}

export enum ASSESSMENT_PHASES {
  REGISTRATION = 'Registration',
  PLANNING = 'Scheduling',
  PREPARATION = 'Preparation',
  ASSESSMENT = 'Assessment',
  DECISION = 'Decision',
  CERTIFICATION = 'Certification',
  SHOW_ALL = 'Show All',
}

export enum ASSESSMENT_FORMS {
  PERSONAL_DATA = 'Data Pemohon',
  CERTIFICATION_DATA = 'Data Sertifikasi',
  PRECONDITION_FORM = 'Dokumen Prasyarat',
  SELF_ASSESSMENT = 'Asesmen Mandiri',
  FORM_APL_01 = 'Form APL 01',
  FROM_APL_02 = 'Form APL 02',
  SUPPORT_DOCUMENT = 'Dokumen Pendukung',
  ANOTHER_DOCUMENT = 'Dokumen Lainnya',
  SCHEDULE = 'Detail Schedule',
  PRE_ASSESSMENT = 'Pre-Assessment',
  ASSESSMENT_DETAIL = 'Assessment Detail',
  DECISION_DETAIL = 'Decision',
}

export enum COLUMN_TYPE {
  QUESTION = 'Question',
  ANSWER = 'Answer',
}

export enum COLUMN_TYPE_ADDITIONAL_QUESTION {
  QUESTION = 'Pertanyaan',
  ANSWER = 'Jawaban',
}

export enum QUESTION_TYPES {
  // ANSWER
  SHORT_ANSWER = 'Short Answer',
  PARAGRAPH = 'Paragraph',
  MULTIPLE_CHOICE = 'Multiple Choice',
  CHECKBOX = 'Checkboxes',
  FILE_UPLOAD = 'File Upload',
  DATE = 'Date',
  TIME = 'Time',
  SLIDER = 'Slider',
  RANK_ORDER = 'Rank Order',

  // QUESTION
  IMAGE = 'Image',
  TEXT = 'Text',
}

export enum ANSWER_TYPES {
  SHORT_ANSWER = 1,
  PARAGRAPH = 2,
  MULTIPLE_CHOICE = 3,
  CHECKBOX = 4,
  FILE_UPLOAD_5
}

export enum QUESTION_LAYOUT {
  VERTICAL = 'Vertical',
  HORIZONTAL = 'Horizontal',
}

export enum GENDERS {
  MAN = 'Laki-Laki',
  WOMEN = 'Wanita',
}

export enum FORM_STATUS {
  FILLED = 'Terisi',
  NOT_FILLED = 'Belum diisi',
  DRAFT = 'Draft',
}

export enum LOADING {
  BASE = 'isLoading',
  DETAIL = 'isDetailLoading',
  ACTION = 'isActionLoading',
  DOWNLOAD = 'isDownloadLoading',
  DROPDOWN = 'isDropdownLoading',
}

export enum LOADING_KEY_TYPE {
  ANSWER_FILES = 'answerFiles',
  ANSWER = 'answer',
  RESULT_DETAIL = 'resultDetail',
}

export enum UPLOAD_TYPE {
  ANSWER = 'Answer',
  QUESTION = 'Question',
}

export enum ASSESSMENT_FEATURES {
  GENERAL_PROOF = 'GENERAL_PROOF',
  RELEVANT_PROOF = 'RELEVANT_PROOF',
  SELF_ASSESSMENT = 'SELF_ASSESSMENT',
}

export const ACTIVE_STRING = 'Aktif';
export const INACTIVE_STRING = 'Tidak Aktif';
export const DRAFT = 'Draft';
export const PUBLISH = 'Publish';

// PROOF
export const QUALIFIED = 'Memenuhi Syarat';
export const NOT_QUALIFIED = 'Tidak Memenuhi Syarat';
export const NOT_EXISTS = 'Tidak Ada';
export const EXISTS = 'Ada';

// Gender
export const MAN = 'Laki-Laki';
export const WOMEN = 'Wanita';

// Options
export const VALID = 'Valid';
export const REAL = 'Asli';
export const LATEST = 'Terkini';
export const ADEQUATE = 'Memadai';

// PROCESS
export const DONE = 'Done';
export const ON_PROGRESS = 'On Progress';

export const NEWS_STATUS: IDropdown[] = [
  { value: ACTIVE_STRING, label: 'app.status.active' },
  { value: INACTIVE_STRING, label: 'app.status.inactive' },
  { value: DRAFT, label: 'app.status.draft' },
  { value: PUBLISH, label: 'app.status.publish' },
];

export const GENDER_DROPDOWN: IDropdown[] = [
  { value: GENDERS.MAN, label: 'app.gender.man' },
  { value: GENDERS.WOMEN, label: 'app.gender.women' },
];

export const GENERAL_PROOFS: IDropdown[] = [
  {
    value: QUALIFIED,
    label: 'app.proofs.general.qualified',
  },
  {
    value: NOT_QUALIFIED,
    label: 'app.proofs.general.notQualified',
  },
  {
    value: NOT_EXISTS,
    label: 'app.nothing',
  },
];

export const RELEVANT_PROOFS: IDropdown[] = [
  {
    value: EXISTS,
    label: 'app.proofs.relevant.exists',
  },
  {
    value: NOT_EXISTS,
    label: 'app.nothing',
  },
];

export const ASSESSOR_ASSESSMENT: IDropdown[] = [
  { label: 'app.assessment.valid', value: VALID },
  { label: 'app.assessment.real', value: REAL },
  { label: 'app.assessment.latest', value: LATEST },
  { label: 'app.assessment.adequate', value: ADEQUATE },
];

export const PROCESSES: IDropdown[] = [
  { label: 'app.done', value: DONE },
  { label: 'app.onProgress', value: ON_PROGRESS },
];

export const ASSESSMENT_STATUS_DROPDOWN: IDropdown[] = Object.values(ASSESSMENT_STATUS).map(approvalStatus => ({
  label: approvalStatus,
  value: approvalStatus,
}));

export const ASSESSMENT_PHASE_DROPDOWN: IDropdown[] = Object.values(ASSESSMENT_PHASES).map(phase => ({
  label: phase,
  value: phase,
}));

export const QUESTION_TYPE_DROPDOWN: IDropdown[] = Object.values(QUESTION_TYPES).map(questionType => ({
  label: questionType,
  value: questionType,
}));

export enum PROCESS {
  DONE = 'Done',
  ON_PROGRESS = 'On Progress',
}
